import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const Contentservice = () => {
  return (
    <div className="sf-services">
      <h3>Our Content Marketing Services</h3>
      <p className="sf-description">
        We offer a huge range of content advertising and marketing services
        designed to help your enterprise develop:
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Blog Writing & Content Strategy</h3>
          <p>
            We create SEO-optimized, studies-based weblog content material that
            attracts your target market, improves search engine scores, builds
            authority, and drives regular natural traffic for your internet
            site.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Website Content Writing</h3>
          <p>
            Our team delivers excellent internet site content material that
            simply communicates your brand message, engages site visitors,
            builds accept as true with, and converts them into loyal customers
            via persuasive and structured copy.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Social Media Content</h3>
          <p>
            We design creative and engaging social media content that reinforces
            brand visibility, increases audience interplay, and allows you
            connect with your clients across a couple of structures
            successfully.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>Email Marketing Content</h3>
          <p>
            We create personalised and conversion-focused e mail campaigns that
            nurture leads, growth engagement, construct sturdy purchaser
            relationships, and pressure better open costs and sales.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>SEO Content Creation</h3>
          <p>
            As a leading content advertising and marketing corporation, we
            develop key-word-rich, search engine optimization-friendly content
            that improves seek ratings, drives natural visitors, and facilitates
            your enterprise reap long-term virtual growth.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Landing Page Content Writing</h3>
          <p>
            We create high-converting landing page content with compelling
            headlines, persuasive copy, and strong CTAs that capture attention,
            engage visitors, and maximize lead generation and conversions.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Guest Posting Services</h3>
          <p>
            We provide high-quality guest posting services to build backlinks,
            increase domain authority, and enhance your brand visibility through
            content published on trusted and relevant websites.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contentservice;
